export default __webpack_public_path__ + "static/media/creditcard-outcome.75ec4d09.svg";